import "./MiniGlitch.css";

export default function MiniGlitchText(props: any) {
    return (<div className="glitch-mini-wrapper">
        <div className="glitch-mini" data-text={props.children}>{props.children}</div>
    </div>);
} 